import type { SevenIgamingPlatformConfig } from '#src/interfaces/sevenIgamingPlatform'
import { SevenIgamingPlatformKey } from '#src/sevenIgamingPlugin'
import { inject } from 'vue'

export function useSevenIgamingPlatformConfig() {
  const config = inject<SevenIgamingPlatformConfig>(SevenIgamingPlatformKey)
  if (!config) {
    throw new Error('SevenIgamingPlatform plugin not installed or config not provided.')
  }
  return config
}
